import { useTheme } from "@ihs-widget/stores/ThemeContext";
import MatchStatus from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/common/MatchStatus/MatchStatus";
import { useEffect, useState } from "react";
import { T } from "@ihs-widget/utils/enums";

type MatchStatusType = typeof T.W | typeof T.L | typeof T.F | typeof T.D | null;

interface TableRowProps {
    no: number;
    leagueName: string;
    teamName: string;
    playedMatches: number;
    plusMinus: string;
    points: number;
    from: MatchStatusType[];
    isHighlighted: boolean;
    qualification?: string | null;
    qualificationRaw?: string | null;
    color?: string | null;
}

const TableRow = ({ no, leagueName, teamName, playedMatches, plusMinus, points, from, isHighlighted, qualification, qualificationRaw, color }: TableRowProps) => {
    const { theme } = useTheme();
    const [isHoverOnRow, setIsHoverOnRow] = useState(false);

    const onHoverOnRow = () => {
        setIsHoverOnRow(!isHoverOnRow);
    }


    const getLeftBorderColor = () => {
        // If we have a color value from API, use it
        if (color) {
            switch (color) {
                case 'green': return 'bg-brand090 dark:bg-brand090';
                case 'yellow': return 'bg-attention dark:bg-attention';
                case 'lightblue': return 'bg-focus dark:bg-focus';
                case 'darkblue': return 'bg-focus110 dark:bg-focus110';
                case 'teal': return 'bg-highlight090 dark:bg-highlight090';
                case 'orange': return 'bg-attention dark:bg-attention';
                case 'red': return 'bg-error dark:bg-error';
                default: return 'bg-transparent';
            }
        }
    }

    useEffect(() => {
        setIsHoverOnRow(isHighlighted);
    }, [isHighlighted]);
    
    return (
        <div data-testid="h2h-table-row" className={`flex flex-row justify-start items-center sm351:w-[319px] w-full h-[32px] 
                        mb-[8px]
                        border-b border-b-base080 dark:border-b-base120 
                        text-[12px] leading-[16px] font-robotoRegular font-normal text-monoX dark:text-monoY
                        ${isHighlighted ? 'bg-base080 dark:bg-monoX' : ''}`}
                       >
            <div data-testid="h2h-table-row-left-border" className={`${getLeftBorderColor()} min-w-[2px] max-w-[2px] h-full`} />
            <div data-testid="h2h-table-row-team-name" className='sm351:w-[123px] sm351:min-w-[123px] sm351:max-w-[123px] sm351:mr-0
                            sm320:w-[36%] sm320:min-w-[36%] sm320:max-w-[36%] mr-[4px] 
                            sm300:w-[28%] sm300:min-w-[28%] sm300:max-w-[28%] sm320:mr-[4px]
                            h-full flex flex-row justify-start items-center ml-[2px] gap-[4px]'>
                <div data-testid="h2h-table-row-place-shortcut" className="w-[14px] flex justify-center items-center dark:text-monoY">{no}</div>
                <div data-testid="h2h-table-row-team-name" className={`sm351:w-[101px] sm351:min-w-[101px] sm351:max-w-[101px] 
                                sm320:w-full 
                                sm300:w-full 
                                w-full 
                                text-base120 dark:text-monoY 
                                ${isHoverOnRow ? 'font-robotoMedium font-medium' : ''} 
                                truncate`}>
                    {teamName}
                </div>
            </div>
            <div data-testid="h2h-table-row-points-and-form" className='sm351:w-[192px] max-w-full h-full flex flex-row justify-start items-center sm351:gap-[8px] gap-[2px]'>
                <div data-testid="h2h-table-row-points-and-form-points-and-form" className="sm351:w-[96px] w-full flex flex-row justify-start items-center sm351:gap-[4px] gap-px">
                    <div data-testid="h2h-table-row-points-and-form-points-and-form-played-matches" className="sm351:w-[22px] w-[22px] dark:text-base090 text-base0 flex justify-center items-center">{playedMatches}</div>
                    <div data-testid="h2h-table-row-points-and-form-points-and-form-plus-minus" className="sm351:w-[44px] w-[44px] dark:text-base090 text-base0 flex justify-center items-center">{plusMinus}</div>
                    <div data-testid="h2h-table-row-points-and-form-points-and-form-points" className="sm351:w-[22px] w-[22px] dark:text-monoY flex justify-center items-center">{points}</div>
                    
                </div>
                <div data-testid="h2h-table-row-points-and-form-form" className="w-[88px] h-full flex flex-row justify-start items-center gap-[2px]">
                    {from.map((date, index) => (
                        index === 0 ? <MatchStatus status={date} key={index} isBottomBar={true} /> : <MatchStatus status={date} key={index} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default TableRow;